import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { chartDays, shortDay } from "./statsLogic";

export const LUNCH = "#b8932f";
export const DINNER = "#5b5446";
const HEIGHT = 190;

// Colonne impilate pranzo (oro) + cena (scuro), una per giorno; i numeri compaiono passando sopra.
const StatsCoversChart = ({ days }) => {
  const { t, i18n } = useTranslation("bookings");
  const [hover, setHover] = useState(null);
  const lang = i18n.language === "en" ? "en" : "it";
  const list = chartDays(days);
  const max = Math.max(1, ...list.map((d) => (d.lunch || 0) + (d.dinner || 0)));
  const labels = list.length <= 14;
  const gap = list.length > 60 ? 1 : list.length > 20 ? 2 : 6;
  const cur = hover !== null ? list[hover] : null;

  return (
    <div>
      <div className="d-flex align-items-center small mb-2" style={{ gap: 16 }}>
        <span><i style={{ display: "inline-block", width: 12, height: 12, background: LUNCH, borderRadius: 2, marginRight: 6, verticalAlign: -1 }} />{t("stats.lunch")}</span>
        <span><i style={{ display: "inline-block", width: 12, height: 12, background: DINNER, borderRadius: 2, marginRight: 6, verticalAlign: -1 }} />{t("stats.dinner")}</span>
        <span className="ml-auto text-muted" style={{ minHeight: 18 }}>
          {cur
            ? `${shortDay(cur.date, lang)} · ${t("stats.lunch")} ${cur.lunch} · ${t("stats.dinner")} ${cur.dinner} · ${t("stats.total")} ${cur.lunch + cur.dinner}`
            : t("stats.chartHint")}
        </span>
      </div>
      <div style={{ position: "relative", borderBottom: "1px solid rgba(128,128,128,.5)", borderTop: "1px dashed rgba(128,128,128,.3)", marginTop: 14 }}>
        <span className="text-muted" style={{ position: "absolute", top: -14, fontSize: 10, right: 0, left: "auto" }}>{max}</span>
        <div style={{ display: "flex", alignItems: "flex-end", height: HEIGHT, gap, paddingTop: 8 }} onMouseLeave={() => setHover(null)}>
          {list.map((d, i) => {
            const tot = (d.lunch || 0) + (d.dinner || 0);
            return (
              <div
                key={d.date}
                onMouseEnter={() => setHover(i)}
                onClick={() => setHover(i)}
                title={`${shortDay(d.date, lang)}: ${t("stats.lunch")} ${d.lunch}, ${t("stats.dinner")} ${d.dinner}`}
                style={{ flex: 1, minWidth: 0, height: "100%", display: "flex", flexDirection: "column", justifyContent: "flex-end", cursor: "default", background: hover === i ? "rgba(184,147,47,.15)" : "transparent", borderRadius: 3 }}
              >
                {tot > 0 && labels && <div className="text-center" style={{ fontSize: 11, lineHeight: "14px" }}>{tot}</div>}
                <div style={{ height: `${((d.dinner || 0) / max) * (HEIGHT - 26)}px`, background: DINNER, borderRadius: d.lunch ? "3px 3px 0 0" : 3 }} />
                <div style={{ height: `${((d.lunch || 0) / max) * (HEIGHT - 26)}px`, background: LUNCH, borderRadius: d.dinner ? "0 0 0 0" : "3px 3px 0 0" }} />
              </div>
            );
          })}
        </div>
      </div>
      {labels && (
        <div style={{ display: "flex", gap }}>
          {list.map((d) => (
            <div key={d.date} className="text-center text-muted text-truncate" style={{ flex: 1, minWidth: 0, fontSize: 11, marginTop: 4 }}>
              {d.today ? <strong style={{ color: LUNCH }}>{shortDay(d.date, lang)}</strong> : shortDay(d.date, lang)}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default StatsCoversChart;
